<div
  class="body ui container"
  fxLayout="column"
>
  <div fxLayout="row" fxLayoutAlign="space-between center" class="top">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <h2 class="ui primary header">FAQs</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button
        *isPermitted="{ id: 'FAQ', action: 'add' }"
        (click)="addFAQ()"
        class="ui small button primary"
      >
        Create New Faq
      </button>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>

  <div class="ui vertical basic segment" *ngIf="success || error">

      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>


  </div>
  <!-- </div> -->
  <div
    fxLayout="row"
    appMargin
    class="ui segment"
    marginB="3"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
    id="dark"
  >
    <!-- <div fxFlex="5%">
      <sui-checkbox> </sui-checkbox>
    </div> -->
    <div fxFlex="15%">QUESTION</div>
    <div fxFlex="grow">ANSWER</div>
    <div fxFlex="15%">DATE ADDED</div>
    <div fxFlex="15%">ADDED BY</div>
    <div fxFlex="10%"></div>
  </div>
  <div
    class="ui vertical basic segment"
    [ngClass]="{ loading: pending }"
    appMargin="0"
    appPadding="0"
  >
    <div
      class="ui segment"
      *ngFor="let workflow of FAQs"
      appMargin
      marginB="3"
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
    >
      <!-- <div fxFlex="5%">
        <sui-checkbox> </sui-checkbox>
      </div> -->
      <div fxFlex="15%">{{ workflow?.question }}</div>
      <div fxFlex="grow">{{ workflow?.answer }}</div>
      <div fxFlex="15%">{{ workflow?.dateCreated | date }}</div>
      <div fxFlex="15%">{{ workflow?.createdBy | createdBy }}</div>
      <div fxFlex="10%">
        <button
          class="ui tiny circular icon orange button"
          *isPermitted="{ id: 'FAQ', action: 'edit' }"
          (click)="editFAQ(workflow)"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="Edit"
        >
          <i class="pencil icon"></i>
        </button>
        <button
          class="ui tiny circular icon red button"
          *isPermitted="{ id: 'FAQ', action: 'remove' }"
          (click)="onDelete(workflow)"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="Delete"
        >
          <i class="trash icon"></i>
        </button>
      </div>
    </div>

    <app-no-record-found *ngIf="FAQs && FAQs.length < 1"></app-no-record-found>
  </div>

  <div class="ui vertical basic segment">
    <div class="ui two column grid">
      <div class="column middle aligned">
        <div class="ui icon small button">
          <i class="database icon"></i>
        </div>
        <a class="ui basic label">{{ totalItems }} Record(s)</a>
      </div>
      <div
        class="column right aligned pagination menu"
        style="margin-left: auto"
      >
        <sui-pagination
          class="small"
          [collectionSize]="totalItems"
          [pageSize]="rows"
          [maxSize]="maxSize"
          [hasEllipses]="false"
          [page]="currentPage"
          (pageChange)="nextPage($event)"
        >
        </sui-pagination>
      </div>
    </div>
  </div>
</div>
